import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { DataserviceComponent } from './../shared/dataservice/dataservice.component'
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {

page = {
    title: 'Home',
    subtitle: 'Welcome Home!',
    content: 'Some home content.',
    image: 'assets/bg00.jpg'
  };

  constructor(private route: ActivatedRoute, public dataservice: DataserviceComponent, private cookieService: CookieService) {
   

  }

  loc: string = 'en';
  enTemplate: Boolean = true;
  ngOnInit() {

    this.loc = this.route.snapshot.queryParamMap.get('loc');

    if (this.loc != null) {
      if (this.loc == 'fr')
        this.enTemplate = false;
      else
        this.enTemplate = true;
    } else {
      
      if (this.cookieService.get('lang') == 'fr')
        this.enTemplate = false;
      else
        this.enTemplate = true;
      
    }

	//this.loc = this.route.snapshot.queryParamMap.get('loc');
	
  }

}
